import { render, staticRenderFns } from "./Current.vue?vue&type=template&id=04bd6bca"
import script from "./Current.vue?vue&type=script&lang=js"
export * from "./Current.vue?vue&type=script&lang=js"
import style0 from "./Current.vue?vue&type=style&index=0&id=04bd6bca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports